import { render, staticRenderFns } from "./Devdup.vue?vue&type=template&id=0e18d022&scoped=true&"
import script from "./Devdup.vue?vue&type=script&lang=js&"
export * from "./Devdup.vue?vue&type=script&lang=js&"
import style0 from "./Devdup.vue?vue&type=style&index=0&id=0e18d022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18d022",
  null
  
)

export default component.exports